import React from 'react';
import LazyPageLoader from '../../../cmp/LazyPageLoader';

const Page = React.lazy(()=>import('./W8BENForm'))

export default function LazyW8BEN(props){
  return <React.Suspense fallback={<LazyPageLoader />}>
    <Page />
  </React.Suspense>
}

